<template>
  <div v-if="!isActive"></div>
  <DiscardChangesModalComponent
    v-else
    :attributes="attributes"
    @confirm-modal="handleAction('confirm')"
    @close-modal="handleAction('close')"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { discardChangesEventBus } from '@/mixins/discardChangesMixin'
import DiscardChangesModalComponent from './DiscardChangesModalComponent.vue'

export default defineComponent({
  components: {
    DiscardChangesModalComponent,
  },

  data() {
    return {
      attributes: {},
      isActive: false,
    }
  },

  mounted() {
    discardChangesEventBus.on('discardChangesModalSync', this.handleInit)
    discardChangesEventBus.on('discardChangesModalDestroy', this.handleDestroy)
  },

  unmounted() {
    discardChangesEventBus.off('discardChangesModalSync', this.handleInit)
    discardChangesEventBus.off('discardChangesModalDestroy', this.handleDestroy)
  },

  methods: {
    handleAction(type) {
      const mapEvent = {
        confirm: 'discardChangesModalConfirm',
        close: 'discardChangesModalClose',
      }
      discardChangesEventBus.emit(mapEvent[type])
    },
    handleDestroy() {
      this.isActive = false
      this.attributes = {}
    },
    handleInit(attr) {
      this.isActive = true
      this.attributes = attr
    },
  },
})
</script>
